'use client';

import LoadingAnimation from '@/components/loading-animation';
import { ROUTER } from '@/constants/router';
import { useAppRouter } from '@/hooks/use-app-router';

import CardList from './card-list';
import SearchHistoryPanel from './search-history-panel';
import TitleList from './title-list';

import type { ISuggestionItem, IDramaInfo } from '@/apis/search';

interface ISearingContentProps {
    keyword: string;
    searchId: string;
    loadingTitle: boolean;
    titleList: ISuggestionItem[];
    loadingCards: boolean;
    hasMore: boolean;
    selectedTitleId: string | null;
    cardList: IDramaInfo[];
    searchHistoryKeywords: string[];
    onSelectTitle: (item: ISuggestionItem) => void;
    onLoadMore: () => Promise<void>;
    onSearchHistoryClear: () => void;
    onSearchHistoryPick: (kw: string) => void;
}

export default function SearingContent(props: ISearingContentProps) {
    const {
        keyword,
        searchId,
        loadingTitle,
        titleList,
        loadingCards,
        hasMore,
        selectedTitleId,
        cardList,
        searchHistoryKeywords,
        onSelectTitle,
        onLoadMore,
        onSearchHistoryClear,
        onSearchHistoryPick,
    } = props;
    const router = useAppRouter();
    const showCardList = Boolean(selectedTitleId);

    const handleCardClick = (item: IDramaInfo) => {
        router.push(`${ROUTER.READER}?drama_id=${item.drama_id}&module_name=search_result`);
    };

    if (!keyword.trim()) {
        return (
            <main className='px-[16px] pt-[52px]'>
                <SearchHistoryPanel
                    keywords={searchHistoryKeywords}
                    onClear={onSearchHistoryClear}
                    onPick={onSearchHistoryPick}
                />
            </main>
        );
    }

    if (loadingTitle || loadingCards) {
        return (
            <main className='px-[16px] pt-[52px] text-[12px] leading-[16px] text-[#000]'>
                <LoadingAnimation visible />
            </main>
        );
    }

    return (
        <main className='px-[16px] pb-[16px] pt-[52px]'>
            {showCardList ? (
                <section>
                    <CardList
                        loading={loadingCards}
                        hasMore={hasMore}
                        keyword={keyword}
                        searchId={searchId}
                        cardList={cardList}
                        onCardClick={handleCardClick}
                        onLoadMore={onLoadMore}
                    />
                </section>
            ) : (
                <section>
                    <TitleList
                        loading={loadingTitle}
                        keyword={keyword}
                        titleList={titleList}
                        onSelectTitle={onSelectTitle}
                    />
                </section>
            )}
        </main>
    );
}
